import useIsMobile from '@/hooks/useIsMobile';
import TopProductDesktop from './desktop';
import TopProductMobile from './mobile';
import useTopProduct from './useTopProduct';

const TopProduct = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useTopProduct();

  if (isMobile) {
    return <TopProductMobile viewModel={viewModel} />;
  }

  return <TopProductDesktop viewModel={viewModel} />;
};

export default TopProduct;
